import {
  IAccountDetailsResponse,
  IAssessmentStateResponse,
  IAuditHistoryPayload,
  IAuditHistoryResponse,
  IProjectOwnersPayload,
  IProjectOwnersResponse,
} from '../../models/DashboardModels';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { storage, STORAGE_CONSTANTS } from '../LocalStorage';
import { ServerType, ServiceType } from '../ServiceType.data';

export class DashboardService {
  private readonly tangraService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.tangra,
  );

  private readonly dcaBackendService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.dcaBackend,
  );

  private readonly dcaBackendUserService: ApiServiceBase = new ApiService(
    ServiceType.user,
    ServerType.dcaBackend,
  );

  public getUserProjects(): Promise<IAccountDetailsResponse[]> | IAccountDetailsResponse[] {
    const userid = storage.getItem(STORAGE_CONSTANTS.userId);
    const route: string[] = [API_ROUTE.PROJECT.GET_PROJECTS];
    return this.dcaBackendService.get({ route: route, query: { userid } });
  }

  public getAuditDetails(): Promise<IAuditHistoryResponse> | IAuditHistoryResponse {
    const route: string[] = [API_ROUTE.AUDIT];
    return this.dcaBackendService.get({ route });
  }
  public getProjectOwners({
    accountId,
    projectId,
  }: IProjectOwnersPayload): Promise<IProjectOwnersResponse[]> | IProjectOwnersResponse[] {
    return this.dcaBackendUserService.get({
      route: [API_ROUTE.DASHBOARD],
      query: { accountId, projectId },
    });
  }

  public getProjectOwnersCWB({
    projectId,
  }: IProjectOwnersPayload): Promise<IProjectOwnersResponse[]> | IProjectOwnersResponse[] {
    return this.dcaBackendUserService.get({
      route: [API_ROUTE.DASHBOARD],
      query: { projectId, cwb_flag: true },
    });
  }

  public saveAuditDetails(
    data: IAuditHistoryPayload,
  ): Promise<IAuditHistoryResponse> | IAuditHistoryResponse {
    const route: string[] = [API_ROUTE.AUDIT];
    return this.dcaBackendService.post({ route }, data);
  }

  public getAssessmentsDetails(
    data: string,
  ): Promise<IAssessmentStateResponse> | IAssessmentStateResponse {
    const route: string[] = [API_ROUTE.ASSESSMENTS.CARDS, data];
    return this.dcaBackendService.get({ route });
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
